import { breakpoints } from '../utils/breakpoints';

const handleMenuAccordion = () => {
  const selectors = {
    item: '.js-accordion',
    subMenu: '.js-submenu',
    inner: '.js-submenu-list',
    link: '.js-accordion-link',
  };

  const state = {
    active: 'is-active',
  };

  if (window.innerWidth > breakpoints['tablet-lg']) return;

  const elems = [...document.querySelectorAll(selectors.item)];
  const links = [...document.querySelectorAll(selectors.link)];

  const hideAllElems = () => {
    elems.forEach((elem) => {
      const subMenu = elem.querySelector(selectors.subMenu);
      const subMenuLink = elem.querySelector(selectors.link);

      subMenu.style.height = 0;
      subMenuLink.classList.remove(state.active);
    });
  };

  const openSubMenu = (elem) => {
    const subMenu = elem.querySelector(selectors.subMenu);
    const subMenuInner = elem.querySelector(selectors.inner);
    const subMenuLink = elem.querySelector(selectors.link);

    const isItemOpened = subMenuLink.classList.contains(state.active);

    hideAllElems();

    if (isItemOpened) return;

    subMenuLink.classList.add(state.active);
    subMenu.style.height = subMenuInner.offsetHeight + 'px';
  };

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });

  elems.forEach((elem) => {
    elem.addEventListener('click', () => openSubMenu(elem));
  });
};

export default handleMenuAccordion;
